import { Box, Typography, Button, Container } from '@mui/material';
import { motion } from 'framer-motion';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { useState } from 'react';


const Test = () => {
  return (
   function SearchFilter() {
  const [query, setQuery] = useState("");
  const users = ["Vinay", "Rahul", "Kiran", "Amit"];

  const filtered = users.filter(u =>
    u.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <>
      <input value={query} onChange={(e) => setQuery(e.target.value)} />
      <ul>
        {filtered.map((u, i) => <li key={i}>{u}</li>)}
      </ul>
    </>
  );
}

  );
};

export default Test;
